import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
	selector: 'app-menu-skeleton-categories',
	standalone: true,
	imports: [CommonModule, IonicModule],
	templateUrl: './menu-skeleton-categories.component.html',
	styleUrls: ['./menu-skeleton-categories.component.scss']
})
export class MenuSkeletonCategoriesComponent {
	skeletonCategories = new Array(6); // Show 6 skeleton category chips
}